import React from 'react';
import { Colors, ChartColors } from '../../../constants/Colors.js';

const ESTADOS = [
  { key: 'alto', label: 'Alto' },
  { key: 'bajo', label: 'Bajo' },
  { key: 'nulo', label: 'Nulo' },
];

/**
 * Barra de composición de las cooperativas por nivel de uso. Es una sola cifra
 * repartida en tres estados, así que se lee mejor como una barra apilada al 100%
 * que como tres barras sueltas.
 */
const UsoSirioDistribucion = ({ filas, umbral }) => {
  const total = filas.length;
  const conteos = ESTADOS.map(estado => ({
    ...estado,
    n: filas.filter(fila => fila.uso_sirio === estado.key).length,
  }));

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
        <h6 className="font-lato-normal-500 heading-box mb-0">Distribución de uso</h6>
        <small style={{ color: Colors.neutral_400 }}>
          Alto = 2 o más módulos con {umbral} registros o más · Bajo = 1 módulo · Nulo = ninguno
        </small>
      </div>

      <div className="d-flex" style={{ height: 26, borderRadius: 6, overflow: 'hidden', backgroundColor: Colors.neutral_50, gap: 2 }}>
        {conteos
          .filter(estado => estado.n > 0)
          .map(estado => (
            <div
              key={estado.key}
              title={`${estado.label}: ${estado.n} cooperativas`}
              style={{
                width: `${(estado.n / total) * 100}%`,
                backgroundColor: ChartColors.estado[estado.key],
                color: Colors.white,
                fontSize: 12,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              {estado.n / total > 0.07 ? estado.n : ''}
            </div>
          ))}
      </div>

      <div className="d-flex flex-wrap mt-2" style={{ gap: 18 }}>
        {conteos.map(estado => (
          <span key={estado.key} className="d-inline-flex align-items-center" style={{ fontSize: 13 }}>
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: 3,
                backgroundColor: ChartColors.estado[estado.key],
                display: 'inline-block',
                marginRight: 6,
              }}
            />
            <span style={{ color: Colors.gray_base }}>
              {estado.label}: <strong style={{ color: Colors.neutral_800 }}>{estado.n}</strong>
              {total > 0 && ` (${Math.round((estado.n / total) * 100)}%)`}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default UsoSirioDistribucion;
